import './index.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';

import App from './App';
import { AppAuthContext } from './context/authContext';

ReactDOM.render(
	<React.StrictMode>
		<AppAuthContext>
			<Router>
				<App />
			</Router>
		</AppAuthContext>
	</React.StrictMode>,
	document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
